var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout-body"}},[_c('div',{staticClass:"body-main"},[_c('router-view')],1),_c('back-top'),_c('login-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }